import {
  ASSISTANT_AUTH_CONFIGURATION_ERROR,
  ASSISTANT_RATE_LIMITED,
  ASSISTANT_UNAVAILABLE,
} from '@/lib/assistant/message-turn';
import type { ChunkType } from '@/lib/mastra/types';
import { readRecord, readString } from '@/lib/prop-utils';

function getErrorCandidates(record: Record<string, unknown>): Record<string, unknown>[] {
  const nestedError = readRecord(record.error);
  const nestedDataError = readRecord(readRecord(record.data)?.error);
  return [record, nestedError, nestedDataError].filter(Boolean) as Record<string, unknown>[];
}

export function getStreamErrorMessage(error: unknown): string {
  const record = readRecord(error);
  if (record) {
    const candidates = getErrorCandidates(record);

    for (const candidate of candidates) {
      const code = (readString(candidate.code) || '').toLowerCase();

      if (code.includes('rate_limit') || code.includes('too_many_requests')) {
        return ASSISTANT_RATE_LIMITED;
      }

      if (code.includes('insufficient_quota')) {
        return ASSISTANT_UNAVAILABLE;
      }

      if (code === 'invalid_api_key') {
        return ASSISTANT_AUTH_CONFIGURATION_ERROR;
      }
    }
  }

  return ASSISTANT_UNAVAILABLE;
}

export function getChunkPayload(chunk: ChunkType): Record<string, unknown> {
  if (!('payload' in chunk)) {
    return {};
  }

  return readRecord(chunk.payload) ?? {};
}

export function getFinishOutputText(payload: unknown): string {
  const output = readRecord(payload)?.output;
  const text = readString(readRecord(output)?.text);
  return text || '';
}

export function getFinishOutputObject(payload: unknown): unknown {
  const output = readRecord(payload)?.output;
  const outputRecord = readRecord(output);
  if (outputRecord && 'object' in outputRecord) {
    return outputRecord.object;
  }

  return output;
}
